import { createSlice } from "@reduxjs/toolkit";
import { ApplicantType } from "../modules/advisors/Constants";

const initialState = {
  proposal: null,
  colleagues: [],
  daysLeft: 0,
};

const proposalSlice = createSlice({
  name: "proposal",
  initialState,
  reducers: {
    setProposal: (state, { payload }) => {
      const {
        applicantLeaderId,
        id,
        programType,
        eligibilitystatus,
        name,
        status,
        numberOfYear,
        generalInfoLink
      } = payload;
      state.proposal = {
        name,
        applicantLeaderId,
        id,
        programType,
        eligibilitystatus,
        status,
        numberOfYears: numberOfYear,
        generalInfoLink
      };
    },
    setProposalNumberOfYears(state, { payload }) {
      state.proposal.numberOfYears = payload;
    },
    setColleagues: (state, { payload }) => {
      state.colleagues = payload;
    },
    setDaysLeft: (state, { payload }) => {
      state.daysLeft = payload;
    },
  },
  extraReducers: {},
});

const { actions, reducer } = proposalSlice;
export const {
  setProposal,
  setColleagues,
  setDaysLeft,
  setProposalNumberOfYears,
} = actions;

export default reducer;

// selectors
export const proposalSelector = (state) => state.proposal.proposal;
export const colleaguesSelector = (state) =>
  state?.proposal?.colleagues || initialState.proposal.colleagues;
export const pisColleaguesSelector = (state) => {
  const c = state?.proposal?.colleagues || initialState.proposal.colleagues;
  return c.filter((c) => c.pici === ApplicantType.PI);
};
export const cisColleaguesSelector = (state) => {
  const c = state?.proposal?.colleagues || initialState.proposal.colleagues;
  return c.filter((c) => c.pici === ApplicantType.CI);
};

export const daysLeftSelector = (state) => state.proposal.daysLeft;
